import { gql } from '@apollo/client';

export const FillerAudio = gql`
    mutation fillerAudio($active: Boolean!, $agentId: ID!) {
        fillerAudio(active: $active, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
